import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["period", "display", "interval", "announcement"]

  connect() {
    this.change()
  }

  change() {
    const period = this.periodTargets.find((input) => input.checked)?.value || "monthly"

    this.displayTargets.forEach((target) => {
      target.textContent = target.dataset[period]
    })
    this.intervalTargets.forEach((target) => {
      target.querySelector('input[name="billing_interval"]').value = period
    })
    this.announcementTarget.textContent = period === "annual"
      ? "Showing annual prices, billed once a year."
      : "Showing monthly prices."
  }
}
